import LocaleWrap from "./wrapPageElement"
export const wrapPageElement = LocaleWrap

